export const initialValuesIpipNeo = {
	age: 0,
}
